import { useWallOfLoveTemplateStore } from "../stores/wall-of-love-template-store";

export const useWallOfLoveTemplates = () => {
	const template = useWallOfLoveTemplateStore((state) => state.template);
	const templates = useWallOfLoveTemplateStore((state) => state.templates);
	const indexWallOfLoveTemplates = useWallOfLoveTemplateStore((state) => state.index);
	const showWallOfLoveTemplate = useWallOfLoveTemplateStore((state) => state.show);

	return { template, templates, indexWallOfLoveTemplates, showWallOfLoveTemplate };
};